<template>
  <v-card flat>
    <v-container>
      <div class="">
        <h3 class="earth-color">FACILITY COMMISSION</h3>
      </div>
      <v-form @submit.prevent="addFacilityCommission()">
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-text-field
                label="Commission Account Code "
                v-model="facility_commission.commission_account_code"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>
          <v-flex lg6 md6 sm12 xs12>
            <v-container fluid>
              <v-text-field
                label="OPC Percentage Commission "
                v-model="facility_commission.percentage_commission"
                type="number"
                :rules="requiredRules"
                required
              ></v-text-field>
            </v-container>
          </v-flex>

          <v-flex lg12 md12 sm12 xs12>
            <v-container>
              <v-btn :depressed="true" color="primary" type="submit"
                >ADD COMMISSION
              </v-btn>
            </v-container>
          </v-flex>
        </v-layout>
      </v-form>
      <table cellpadding="1" cellspacing="1" class="table table-bordered">
        <thead>
          <tr>
            <td>Commission Account Code</td>
            <td>OPC Percent Commission</td>
            <td>Start Date</td>
            <td>End Date</td>
            <td>Updated By</td>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(d, key) in externalFacilityCommission" :key="key">
            <td>{{ d.commission_account_code }}</td>
            <td>{{ d.percentage_commission }}%</td>
            <!-- <td>{{ formated_date(d.created_at) }}</td>
             -->
              <td>{{ formated_date(d.created_at) }}</td>
              <td  v-if="d.updated_at==null">Current</td>
              <td  v-else>{{ formated_date(d.updated_at) }}</td>
            <td>{{ d.user }}</td>
            <td></td>
          </tr>
        </tbody>
      </table>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "extra-pricing",
  data() {
    return {
      requiredRules: [v => !!v || "This field is required"],

      facility_commission: {
        commission_account_code: "",
        percentage_commission: "",
        session_id: localStorage.getItem("lkjhgfdsa"),
        facility_id: this.$route.params.facility_id
      }
    };
  },
  methods: {
    addFacilityCommission: function() {
      this.$store.dispatch(
        "post_facility_commission",
        this.facility_commission
      );
    }
  },
  created() {
    this.$store.dispatch(
      "get_facility_commission",
      this.$route.params.facility_id
    );
    // this.$store.dispatch("get_all_currency_types");
    // this.$store.dispatch("get_all_facility_pricing_types");
  }
};
</script>

<style scoped></style>
